export const INSTALLATION_SCHEDULING = 'Installation is scheduled with you after fabrication is complete.';
export const FINISHED_PARTS_STORAGE = 'Storage of finished parts beyond 14 business days after fabrication is complete is invoiced weekly at $50 per week. All storage charges must be paid in full before installation.';

/** Update unsigned, saved estimates without losing the client's requested window. */
export function currentInstallationTiming(lines: readonly string[] = []): string[] {
  return lines.map(line => line.replace(/dates (?:are )?confirmed after (?:final )?design approval/gi, 'installation scheduled with you after fabrication is complete'));
}
